<template>
    <div class="px-2 pt-6">
        <div class="row">
            <div class="col-xs-4 col-sm-4 col-md-3 col-xl-2">
                <v-btn small class="ma-0" @click="$router.back()" color="info" outlined> 
                    <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras 
                </v-btn>
                <v-btn color="blue" small outlined dark :loading="loading" @click="getDatos()"> <v-icon>mdi-refresh</v-icon> </v-btn>
            </div>
            <div class="col-xs-2">
                <v-select label="MES" :items="meses()" v-model="query.mes" item-value="id" dense />
            </div>
            <div class="col-xs-2">
                <v-select label="GESTION" :items="anios()" v-model="query.anio" item-value="id" dense />
            </div>
        </div>

        <h5 class="text-center blue darken-4 py-2">
            <b class="white--text"> Lista de programas aprobados para Oferta academica DBS  </b>
        </h5>  

        <v-data-table
            :headers="headers_apb"
            :items="aprobados"
            :loading="loading" 
            dense
            disable-pagination 
            hide-default-footer
            :items-per-page="50"
            class="elevation-0 mx-8">
    
            <template v-slot:[`item.ind`]="a">
                <span> {{ a.index + 1 }} </span>
            </template> 
            <template v-slot:[`item.fecha_inicio_campania`]="{item}">
                <span> {{ parseDateFecha(item.fecha_inicio_campania, false) }} </span>
            </template> 
            <template v-slot:[`item.fecha_fin_campania`]="{item}">
                <span> {{ parseDateFecha(item.fecha_fin_campania, false) }} </span>
            </template>
            <template v-slot:[`item.fecha_inicio_campania_reprog`]="{item}">
                <span> {{ parseDateFecha(item.fecha_inicio_campania_reprog, false) }} </span>
            </template>
            <template v-slot:[`item.fecha_fin_campania_reprog`]="{item}">
                <span> {{ parseDateFecha(item.fecha_fin_campania_reprog, false) }} </span>
            </template> 
            <template v-slot:[`item.fecha_primer_inscrito`]="{item}">
                <span> {{ parseDateFecha(item.fecha_primer_inscrito, false) }} </span>
            </template> 
            <template v-slot:[`item.estado_aprobacion`]="{item}">
                <v-badge v-if="item.estado_aprobacion=='PENDIENTE'" dot color="orange" />
                <v-badge v-if="item.estado_aprobacion=='APROBADO'" dot color="green" />
                <v-badge v-if="item.estado_aprobacion=='RECHAZADO'" dot color="red" />
                <span> &nbsp;{{ item.estado_aprobacion }} </span> 
            </template> 
        </v-data-table>   
    </div>
</template>
  
<script> 
import { anios, getMesAnioActual, headers_aprob, meses, parseDatos} from './utils.ts'
import { getPosgrado } from '../autoria/utils.ts';
import { oferta_esam_listado } from '../servicios/seleccionService.ts';
import { parseDateFecha } from '../util.ts';

export default {
    components: {}, 
    data() {
        return {
            loading: false,
            headers_apb: headers_aprob,  
            aprobados: [], 
            parseDateFecha,
            query:{
                mes: null,
                anio: null,
            },   
            anios,
            meses,
        };
    },
    watch: {
        '$store.state.CARGO': function( ){  
            const u = this.$store.state.CARGO.sede.unidad_negocio;
            if( u==1 ) this.$router.push({ name: 'oferta_oficial_esam' });
            else this.getDatos();
        }, 
    },
    methods: {
        async getDatos(){
            this.aprobados = [];  
            this.loading = true;
            const query = {}
            query.mes = this.query.mes
            query.anio = this.query.anio
            query.unidad_negocio_id = 10;
            const r = await oferta_esam_listado(query)
            if(r && r.oferta_esam_listado){
                const ls = r.oferta_esam_listado;
                parseDatos(ls)
                this.aprobados = ls; 
            } 
            this.loading = false;
        },  
 
        async crearPrograma(proy){ 
            const ispermitido = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 5 || this.$store.state.CARGO.id == 6;
            if(!ispermitido){
                this.$root.$notify.show('no tiene autorizacion.', {color:'red',x: 'right',timeout:1800});
                return;
            }
            const item = await getPosgrado(this,proy.postgrado_id)
            
            this.$store.dispatch('postgrado/selectPostgrado', item);
            window.sessionStorage.setItem('xpostgradorest', JSON.stringify(item));
            this.$router.push({ name: 'programaviewrest' });
        }, 
    },
    mounted() {   
        const d = getMesAnioActual()
        this.query.mes = d.mes;
        this.query.anio = d.anio;
        window.console.log('>>>', d);
        
        this.getDatos();  
    },
};
</script>
  